// components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import Constants from "../../../services/constants";
import FacebookLogo from "../../../assets/logo/facebookLogo.png"
import YoutubeLogo from "../../../assets/logo/youtube-icon.png"
import InstaLogo from "../../../assets/logo/instaLogo.png"


const FOOTER_LINKS = [
  {
    heading: "Account",
    links: [
      ["Free Trial", "/register/free"],
      ["Pricing",    "/home#card-container"],
      ["Sign In",    "/login"],
    ],
  },
  {
    heading: "Platform",
    links: [
      ["Music",    "/library"],
      ["SFX",  "/sfx"],
      ["Now Out",  "/new-inspiration"],
      ["Labels",   "/catalogs"],
    ],
  },
  {
    heading: "Company",
    links: [
      ["About Us", "/about", true],
      ["FAQs",     "/faqs"],
      ["Contact",  "/contact"],
      ["Terms",    "/terms"],
      ["Privacy",  "/privacy"],
      // ["Blog",     "/blogs"],
    ],
  },
];

export default function Footer() {
  return (
    <footer className="landing-footer">
      {/* Top row */}
      <div className="flex justify-between items-start flex-wrap gap-10 mb-4">
        {/* Brand */}
        <div>
          <a
            href="/home"
            className="font-syne text-2xl font-extrabold white-text no-underline block mb-2"
          >
            SYNC<span className="pink-text">MAMA</span>
          </a>
          <div className="w-full flex justify-start my-2 space-x-8">
            
            <div className="">
              <a href={Constants.SM_FACEBOOK_LINK} target="_blank">
                <img
                  src={FacebookLogo}
                  alt="logo"
                  className="h-6"
                  title="Facebook"
                />
              </a>
            </div>
            <div className="">
              <a href={Constants.SM_YOUTUBE_LINK} target="_blank">
                <img
                  src={YoutubeLogo}
                  alt="logo"
                  className="h-6"
                  title="Youtube"
                />
              </a>
            </div>
            <div className="">
              <a href={Constants.SM_INSTA_LINK} target="_blank">
                <img
                  src={InstaLogo}
                  alt="logo"
                  className="h-6"
                  title="Instagram"
                />
              </a>
            </div>
          </div>
          <p className="text-sm white-text max-w-200 leading-[1.6]">
            Made with ❤️ in India.
          </p>
        </div>

        {/* Link columns */}
        {FOOTER_LINKS.map(({ heading, links }) => (
          <div key={heading}>
            <h4 className="text-md font-semibold tracking-[1.5px] uppercase navy-text-1 mb-2 font-dm">
              {heading}
            </h4>
            {links.map(([label, href, internal]) => (
              <a
                key={label}
                href={href}
                className="
                  block text-sm white-text no-underline mb-2 font-dm
                  transition-colors duration-200
                "
              >
                {label}
              </a>
            ))}
          </div>
        ))}
      </div>

      {/* Bottom bar */}
      <div className="
        flex justify-center items-center flex-wrap gap-3
        py-2 border-t border-white
        text-xs white-text font-dm
      ">
        <span>© 2026 · Silk Road Communications</span>
      </div>
    </footer>
  );
}
